<template>
  <!-- ====== Shoping cart Default template ====== -->
  <section
    class="cart_default_sec main-cart"
    :style="cartData.item_count == 0 ? 'display:block' : 'display:none'"
  >
    <div class="big_container">
      <div class="sec_head">
        <div class="pre_arrow_wrapper">
          <button class="prev_cta" @click="prevPage">
            <img
              src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/left-arrow-new.svg?v=1654580925"
              alt="Left Arrow"
              loading="lazy"
              aria-label="Left Arrow"
              width=""
              height=""
            />
          </button>
        </div>
      </div>
      <div class="sec_content">
        <h3 class="cart_heading" v-html="shopifyData.defaultSecHeading" />
        <p class="body_text" v-html="shopifyData.defaultSecInfo" />
        <div class="cta_wrapper">
          <template v-for="(item, index) in shopifyData.section_cta" :key="index">
            <a
              :href="item.secCtaLink"
              class="cta_btn cta_btn-black"
              aria-label="Section CTA"
              v-html="item.secCta"
            />
          </template>
        </div>
      </div>
    </div>
  </section>

  <!-- ====== Shoping cart With Products template ====== -->
  <section
    class="cart_with_products"
    :style="cartData.item_count > 0 ? 'display:block' : 'display:none'"
  >
    <div class="big_container">
      <div class="sec_head">
        <div class="pre_arrow_wrapper">
          <button class="prev_cta" aria-label="Previous Page" type="button" @click="prevPage">
            <img
              src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/left-arrow-new.svg?v=1654580925"
              alt="Left Arrow"
              loading="lazy"
              aria-label="Left Arrow"
              width=""
              height=""
            />
          </button>
        </div>
      </div>
      <div class="sec_content">
        <div class="sec_left">
          <h3 class="cart_heading" v-html="shopifyData.defaultSecHeading" />

          <div class="product_grid main_cart_product_grid">
            <div
              v-for="(value, key) in cartData.items"
              :key="key"
              class="card main_cart_product_card"
              :class="{ 'third-party-free-gift': isFreeGift(value) }"
            >
              <div id="product_img_wrapper" class="product_img_wrapper">
                <div class="loder_tmb">
                  <span /><span /> <span /><span />
                  <span />
                </div>
                <img
                  :id="value.id"
                  v-lazy="value.featured_image.url"
                  :alt="value.featured_image.alt || 'Product Image'"
                  loading="lazy"
                  aria-label="Product Image"
                  width=""
                  height=""
                />
                <button
                  class="body_text1 remove"
                  :variant="value.key"
                  aria-label="Remove Product"
                  type="button"
                  @click="removeCart"
                >
                  Remove
                </button>
              </div>
              <!-- Product Title -->
              <h5
                class="card-title main_cart_product_title"
                v-html="cleanTitle(value.product_title)"
              />

              <!-- Price Section -->
              <div>
                <!-- IF DISCOUNT APPLIED -->
                <div v-if="value.discounts && value.discounts.length > 0">
                  <div class="main_cart_price_container">
                    <!-- Coupon Name -->
                    <h5 class="card-title bold">
                      {{ value.discounts[0].title.replace(/\./g, '') }}
                    </h5>
                    <!-- Original Price -->
                    <span class="tmb_original_price">
                      <del>
                        {{
                          new Intl.NumberFormat(shopLocale, {
                            style: 'currency',
                            currency: currencyCode,
                          }).format(value.original_price / 100)
                        }}
                      </del>
                    </span>

                    <!-- Discounted Price -->
                    <h5 class="card-title bold">
                      {{
                        new Intl.NumberFormat(shopLocale, {
                          style: 'currency',
                          currency: currencyCode,
                        }).format(value.final_price / 100)
                      }}
                    </h5>
                  </div>
                </div>

                <!-- IF NO DISCOUNT -->
                <div v-else>
                  <h5 class="card-title bold">
                    {{
                      new Intl.NumberFormat(shopLocale, {
                        style: 'currency',
                        currency: currencyCode,
                      }).format(value.price / 100)
                    }}
                  </h5>
                </div>
              </div>

              <!-- Product Quantity Update in Cart Start -->
              <div
                :class="{ 'discount-active': value.discounts.length > 0 }"
                class="tmb-quantity_cta"
                :data-id="value.id"
                :data-url="value.url"
                :data-stock="shopifyData.cart_inventory[key].inventory_quantity"
              >
                <span
                  id="btn-decrement"
                  class="update_cta"
                  aria-label="Decrement Quantity"
                  type="button"
                  @click="updateQuantity($event, 'minus')"
                >
                  <svg
                    width="21"
                    height="3"
                    viewBox="0 0 21 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 1.49976L21 1.49976" stroke="#656565" stroke-width="1.5" />
                  </svg>
                </span>

                <input
                  type="number"
                  name="quantity"
                  :value="value.quantity"
                  readonly
                  size="3"
                  class="quantity_input"
                />

                <span
                  id="btn-increment"
                  class="update_cta"
                  :style="[
                    value.quantity >= shopifyData.cart_inventory[key].inventory_quantity
                      ? { pointerEvents: 'none', opacity: '0.3' }
                      : { pointerEvents: 'auto', opacity: '1' },
                  ]"
                  aria-label="Increment Quantity"
                  type="button"
                  @click="updateQuantity($event, 'plus')"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.4999 0L10.4999 21" stroke="#656565" stroke-width="1.5" />
                    <path d="M0 10.4998L21 10.4998" stroke="#656565" stroke-width="1.5" />
                  </svg>
                </span>
              </div>
              <!-- Product Quantity Update in Cart End -->
            </div>
          </div>
        </div>
        <div class="sec_right">
          <form>
            <div class="sec_right_inner">
              <h4 class="subtotal_heading" v-html="shopifyData.subtotalHeading" />

              <p class="subtotal_price body_text">
                {{
                  new Intl.NumberFormat(shopLocale, {
                    style: 'currency',
                    currency: currencyCode,
                  }).format(cartData.items_subtotal_price / 100)
                }}
              </p>

              <p class="body_text subtotal_amount" v-html="shopifyData.taxInfo" />
              <div class="cta_wrapper">
                <a
                  class="cta_btn"
                  href="/checkout"
                  aria-label="Checkout"
                  type="button"
                  v-html="shopifyData.checkoutCtaText"
                />
                <a
                  :href="shopifyData.continuCtaLink"
                  class="cta_btn cta-modifier"
                  aria-label="Continue Shopping"
                  type="button"
                  v-html="shopifyData.continuCtaText"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <!-- ====== Thanks template ====== -->
  <section class="thanks_sec">
    <div class="big_container">
      <div class="sec_head">
        <div class="pre_arrow_wrapper">
          <button class="prev_cta" aria-label="Previous Page" type="button" @click="prevPage">
            <img
              src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/left-arrow-new.svg?v=1654580925"
              alt="Left Arrow"
              loading="lazy"
              aria-label="Left Arrow"
              width=""
              height=""
            />
          </button>
        </div>
      </div>
      <div class="sec_content">
        <h3 class="cart_heading" v-html="shopifyData.thanksSecHeading" />
        <p class="body_text" v-html="shopifyData.thanksSecInfo" />
        <div class="cta_wrapper">
          <a
            :href="shopifyData.ThanksSecCtaLink"
            class="cta_btn cta_btn-black"
            aria-label="Thanks Section CTA"
            type="button"
            v-html="shopifyData.ThanksSecCtaText"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ShopifyAPI } from '../../../Shopify/Shopify';
import { currencyJson } from '@/currency';
import { shopConfig } from '@/config/shopConfig';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      shopLocale: shopConfig.locale,
      currencyCode: shopConfig.currency,
      cartData: {
        token: '9b9e4cdf20fe5bf6b5692639c8876a96',
        note: null,
        attributes: {},
        original_total_price: 0,
        total_price: 0,
        total_discount: 0,
        total_weight: 0,
        item_count: 0,
        items: [],
        requires_shipping: false,
        currency: 'USD',
        items_subtotal_price: 0,
        cart_level_discount_applications: [],
      },
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
    };
  },
  mounted() {
    this.refreshMainCart();
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
  },
  methods: {
    isFreeGift(item) {
      console.log('item', item);
      console.log('item.final_line_price', item.final_line_price);
      console.log('item.original_line_price', item.original_line_price);
      console.log('item.line_level_total_discount', item.line_level_total_discount);
      return (
        Number(item.final_line_price) === 0 &&
        Number(item.original_line_price) > 0 &&
        Number(item.line_level_total_discount) > 0
      );
    },
    cleanTitle(str) {
      if (!str) return '';
      return str
        .normalize('NFC') // encoding normalize
        .replaceAll('Â°', '°') // common Shopify encoding fix
        .replaceAll('Â', ''); // extra broken byte cleanup
    },
    refreshMainCart() {
      // console.log(this.shopifyData);
      let data = window.atob(this.shopifyData.cartItems); // decode cart string
      data = JSON.parse(data);
      // console.log('mainCartData', data);
      this.cartData = data;
    },
    prevPage() {
      if (window.history.back()) {
        window.location.url = window.history.back();
      }
    },

    async updateQuantity(event, type) {
      const dd = this;
      const inputParent = event.target.closest('.tmb-quantity_cta');
      const inputValue = inputParent.querySelector('.quantity_input');
      const increBtn = inputParent.querySelector('#btn-increment');
      if (inputValue.value > 0) {
        if (type == 'plus') {
          inputValue.value = Number(inputValue.value) + 1;
        } else {
          inputValue.value = Number(inputValue.value) - 1;
        }
      }
      const item = {
        id: inputParent.getAttribute('data-id'),
        quantity: inputValue.value,
      };
      const shopifyApi = new ShopifyAPI();
      const productData = inputParent.getAttribute('data-stock');
      if (inputValue.value >= Number(productData)) {
        increBtn.style.opacity = '0.3';
        increBtn.style.pointerEvents = 'none';
      } else {
        increBtn.style.opacity = '1';
        increBtn.style.pointerEvents = 'auto';
      }
      const newData = await shopifyApi.removeItem(item);
      dd.cartData = newData.data;
    },

    async removeCart(event) {
      const dd = this;
      event.target.closest('.card').classList.add('active');
      const variant = event.target.getAttribute('variant');
      const shopifyApi = new ShopifyAPI();
      const item = {
        id: variant,
        quantity: 0,
      };
      const newData = await shopifyApi.removeItem(item);
      event.target.closest('.card').classList.remove('active');
      await new Promise((r) => setTimeout(r, 500));
      dd.cartData = newData.data;
    },
  },
};
</script>

<style scoped>
.cart_default_sec,
.cart_with_products,
.thanks_sec {
  padding: 45px 50px 179px;
}

.big_container {
  padding: 0;
}

.cart_default_sec,
.thanks_sec {
  display: none;
}

.cart_default_sec .sec_content {
  max-width: 365px;
  width: 100%;
  margin: 43px auto 0;
}

.pre_arrow_wrapper img {
  cursor: pointer;
}

.main_cart_price_container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}

.main_cart_price_container .card-title {
  margin-top: 0 !important;
}

.subtotal_price.body_text {
  margin-bottom: 5px;
}

.cart_heading {
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #000000;
  margin-bottom: 42px;
}

.cart_default_sec .body_text {
  margin-bottom: 41px;
  font-family: 'Helvetica Neue', sans-serif;
}

.cta_wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 45px;
}

.tmb_original_price del {
  color: #b4b4b4;
  font-size: 12px;
  line-height: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
}

.tmb_original_price .cart_with_products .cart_heading {
  margin: 47px 0 27px;
}

.cart_with_products .sec_content {
  display: flex;
  align-items: flex-start;
  gap: 170px;
}

.cart_with_products .sec_left {
  width: 62%;
}

.cart_with_products .sec_right {
  width: 38%;
  height: 100vh;
  position: sticky;
  top: 100px;
  left: 0;
  padding-left: 70px;
  border-left: 1px solid #000;
}

.main_cart_product_card.third-party-free-gift .tmb-quantity_cta {
  display: none;
}

.product_grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 6px;
  row-gap: 28px;
}

.card .card-title {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  margin-top: 6px;
}

.card-title.bold {
  font-weight: 700;
}

.subtotal_heading {
  margin-bottom: 41px;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.02em;
  color: #000000;
}

.cart_with_products .body_text {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12px;
  line-height: 14px;
}

.subtotal_price {
  font-weight: bold;
}

.logo_wrapper {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.logo_wrapper img {
  width: 90px;
}

.body_text.text-mdifier {
  margin-top: 15px;
  font-weight: 600;
}

.cart_with_products .cta_btn {
  padding: 20px 19px;
  background: #000;
  color: #ffff;
  max-width: 377px;
  width: 100%;
  text-align: center;
  border: 1px solid transparent;
}

.cart_with_products .cta_btn.cta-modifier {
  padding: 0;
  background: unset;
  color: #000;
  max-width: 100%;
  width: 100%;
  text-align: start;
  border: 1px solid transparent;
  text-decoration-line: underline;
  font-size: 12px;
  font-weight: 400;
}

.cart_with_products .cta_btn:hover {
  border-color: #000;
  background: #fff;
  color: #000;
}

.cart_with_products .cta_btn.cta-modifier:hover {
  border-color: transparent;
  background: unset;
  color: #000;
}

.cart_with_products .cta_wrapper {
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.product_img_wrapper {
  position: relative;
}

.body_text.remove {
  position: absolute;
  top: 10px;
  right: 11px;
  text-decoration: underline;
}

.subtotal_price.body_text {
  font-size: 14px;
}

.freeTitle {
  color: red !important;
}

/* Thanks sec css */
.thanks_sec .sec_content {
  max-width: 365px;
  width: 100%;
  margin: 43px auto 0;
}

.thanks_sec .sec_content .body_text {
  font-size: 12px;
  line-height: 14.32px;
  font-family: 'Helvetica Neue', sans-serif;
}

.thanks_sec .cart_heading {
  margin-bottom: 10px;
}

.thanks_sec .cta_wrapper {
  margin-top: 73px;
}

.body_text1.remove {
  position: absolute;
  text-decoration: underline;
  top: 13px;
  right: 11px;
  z-index: 1;
}

/* RESPONSIVE BREAKPOINTS */

@media (max-width: 1200px) {
  .cart_with_products .sec_content {
    gap: 25px;
  }
}

@media (max-width: 1024px) {
  .cart_with_products .sec_right {
    padding-left: 0;
    border-left: none;
    border-top: 1px solid #000;
    padding-top: 30px;
  }

  .cart_with_products .sec_content {
    flex-direction: column;
  }

  .cart_with_products .sec_left,
  .cart_with_products .sec_right {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 991px) {
  .cart_with_products,
  .cart_default_sec {
    display: none;
  }
}

@media (max-width: 480px) {
  .cart_default_sec,
  .cart_with_products,
  .thanks_sec {
    padding: 45px 20px 100px;
  }

  .thanks_sec .cta_wrapper {
    justify-content: center;
  }

  .product_grid {
    grid-template-columns: 1fr;
  }
}

/* Product Quantity Update in Cart Start */
.tmb-quantity_cta {
  display: flex;
  align-items: center;
  margin-top: 20px;
  max-width: 122px;
  width: 100%;
  height: 21px;
}

.tmb-quantity_cta input::-webkit-outer-spin-button,
.tmb-quantity_cta input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.tmb-quantity_cta input {
  display: block;
  border: none;
  width: 47px;
  margin: 0 auto;
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #000000;
  text-align: center;
}

.tmb-quantity_cta input:focus {
  border: none;
  appearance: textfield;
  -moz-appearance: textfield;
}

.tmb-quantity_cta input:focus-visible {
  outline: none;
}

.update_cta {
  display: block;
  line-height: 0;
  cursor: pointer;
}

@media (max-width: 768px) {
  .tmb-quantity_cta {
    margin-top: 24px;
  }
}

/* Product Quantity Update in Cart End */
</style>
